/* eslint-disable */
export default {
  log: '记录',
} as const;

// @key: @#@"log"@#@ @source: @#@"Log"@#@
